"use strict";

var _interopRequireDefault = require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _regeneratorRuntime2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/mac/Documents/project/my-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _importProduct = require("@/api/importProduct");
var _vuePropertyDecorator = require("vue-property-decorator");
var _POTable = _interopRequireDefault(require("./POTable.vue"));
var PO = /*#__PURE__*/function (_Vue) {
  function PO() {
    var _this;
    (0, _classCallCheck2.default)(this, PO);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, PO, [].concat(args));
    (0, _defineProperty2.default)(_this, "query", {
      page: 1,
      limit: 10,
      search: "",
      categoryId: null
    });
    (0, _defineProperty2.default)(_this, "total", 0);
    (0, _defineProperty2.default)(_this, "data", []);
    (0, _defineProperty2.default)(_this, "loading", false);
    (0, _defineProperty2.default)(_this, "tabName", "");
    (0, _defineProperty2.default)(_this, "categories", []);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    return _this;
  }
  (0, _inherits2.default)(PO, _Vue);
  return (0, _createClass2.default)(PO, [{
    key: "transformTable",
    get: function get() {
      var data = [];
      this.data.forEach(function (e) {
        e.totalProduct = e.detailImports.length;
        e.totalQuantityDelivery = 0;
        e.totalQuantityImport = 0;
        e.detailImports.forEach(function (detail) {
          e.totalQuantityImport += +detail.quantityImport;
        });
        e.importWarehouses.forEach(function (importDetail) {
          importDetail.detailWarehouses.forEach(function (detail) {
            e.totalQuantityDelivery += +detail.quantityDelivery;
          });
        });
        e.delivertPercent = e.totalQuantityDelivery / e.totalQuantityImport * 100;
        data.push(e);
      });
      return data;
    }
  }, {
    key: "created",
    value: function created() {
      this.fetchData();
    }
    // handleChange(value) {
    //   this.query.page = 1;
    //   this.query.categoryId = value.name;
    //   this.fetchData();
    // }
  }, {
    key: "handleAdd",
    value: function handleAdd() {}
    // async fetchCategory() {
    //   const excludes = ["MPEF", "QTKH", "TCN"];
    //   const res = await nhanhApi.productCategory();
    //   this.categories = res.data.filter((e) => !excludes.includes(e.code));
    //   if (this.categories.length) {
    //     this.tabName = this.categories[0].id;
    //     this.query.categoryId = this.categories[0].id;
    //   }
    // }
  }, {
    key: "fetchData",
    value: function () {
      var _fetchData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _importProduct.importProductApi.findAll(this.query);
            case 2:
              res = _context.sent;
              this.data = res.data.importProducts;
              this.total = res.data.total;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }
      return fetchData;
    }()
  }]);
}(_vuePropertyDecorator.Vue);
PO = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    POTable: _POTable.default
  }
})], PO);
var _default = exports.default = PO;